import { z } from 'zod'

/** 企業帳號 - 寄送綁定企業會員邀請信by識別碼 Schema */
export const sendInvitationByEmailSchema = z.object({
  /** email */
  email: z.array(z.string())
})

/** 企業帳號 - 寄送綁定企業會員邀請信by識別碼 */
export interface SendInvitationByEmail
  extends z.infer<typeof sendInvitationByEmailSchema> {}
